import { useState, useEffect } from 'react';
import axios from 'axios';
import { tokens } from "../../theme";
import { DataGrid } from '@mui/x-data-grid';
import Header from '../../components/Header';
import { Box, IconButton } from "@mui/material";
import { Autocomplete, TextField } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

function AddPurchase() {
  const [products, setProducts] = useState([]);
  const [selectedProductId] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [purchaseItem, setPurchaseItem] = useState([]);
  // Default to today (YYYY-MM-DD format)
  const [purchaseDate, setPurchaseDate] = useState(new Date().toISOString().split("T")[0]);
  const [file, setFile] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [paidAmount, setPaidAmount] = useState(0);
  const [dueDate, setDueDate] = useState("");
  // Load suppliers for potential future use (e.g., dropdown)
  useEffect(() => {
    axios.get("https://store.petplanet.rw/api/suppliers")
      .then(res => setSuppliers(res.data))
      .catch(err => console.error("Error fetching suppliers:", err));
  }, []);


  // Load all products
  useEffect(() => {
    axios.get('https://store.petplanet.rw/api/products')
      .then(res => setProducts(res.data))
      .catch(err => console.error('Error fetching products:', err));
  }, []);
  
  // Set selected product based on dropdown
  useEffect(() => {
    const found = products.find(p => String(p.id) === selectedProductId);
    setSelectedProduct(found || null);
  }, [selectedProductId, products]);

  const handleDateChange = (id, value) => {
    setPurchaseItem(prev =>
      prev.map(item =>
        item.id === id ? { ...item, purchase_date: value } : item
      )
    );
  };
  
 const uploadExcel = async () => {
  if (!file) {
    alert("Please upload a file");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    const res = await fetch("https://store.petplanet.rw/api/purchases/upload-excel", {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    console.log(data);
    alert("Upload successful");
  } catch (error) {
    console.error(error);
    alert("Upload failed");
  }
};
  const handleSupplierChange = (id, value) => {
    setPurchaseItem(prev =>
      prev.map(item =>
        item.id === id ? { ...item, supplier_id: value } : item
      )
    );
  };
  
  const handleAddToTable = () => {
    if (!selectedProduct) return;
  
    const exists = purchaseItem.find(item => item.product_id === selectedProduct.id);
    if (exists) {
      alert("Product already added!");
      return;
    }
  
    const newItem = {
      id: selectedProduct.id,
      product_id: selectedProduct.id,
      name: selectedProduct.name,
      supplier_id: "",
      buying_price: parseFloat(selectedProduct.buying_price),
      quantity: 1,
      total: parseFloat(selectedProduct.buying_price),
      purchase_date: purchaseDate
    };
    setPurchaseItem(prev => [...prev, newItem]);
    setSelectedProduct(null);  // clear selection after adding
  };


  const handleQuantityChange = (id, value) => {
    setPurchaseItem(prev =>
      prev.map(item =>
        item.id === id
          ? { 
              ...item, 
              quantity: value, 
              total: (item.buying_price * value).toFixed(2) 
            }
          : item
      )
    );
  };

  const handleBuyingPriceChange = (id, value) => {
    setPurchaseItem(prev =>
      prev.map(item =>
        item.id === id ? { ...item, buying_price: value } : item
      )
    );
  };
  
  const handleRemove = (id) => {
    setPurchaseItem(prev => prev.filter(item => item.id !== id));
  };
  
const handleSubmitAll = async () => {
  if (purchaseItem.length === 0) {
    return alert("No products added.");
  }

  try {
    for (const item of purchaseItem) {
      const payload = {
        product_id: item.product_id,
        supplier_id: item.supplier_id,
        quantity: item.quantity,
        buying_price: item.buying_price,
        total: item.total,
        purchase_date: item.purchase_date,
        paid_amount: paidAmount,
        due_date: balance > 0 ? dueDate : null
      };

      await axios.post("https://store.petplanet.rw/api/purchases", payload);
    }

    alert("All purchases submitted successfully!");

    setPurchaseItem([]);
    setPaidAmount(0);
    setDueDate("");
    setIsPaymentModalOpen(false);

  } catch (err) {
    console.error(err);
    alert("Submission failed");
  }
};
  const totalPurchaseAmount = purchaseItem.reduce(
    (sum, item) => sum + Number(item.total),
    0
  );
  
  const balance = totalPurchaseAmount - paidAmount;

  
  const columns = [
    { field: 'name', headerName: 'Product Name', flex: 1, cellClassName: "name-column--cell",},
    {
      field: 'buying_price',
      headerName: 'Buying Price',
      flex: 1,
      renderCell: (params) => (
        <input
          type="number"
          min="0"
          value={params.row.buying_price}
          onChange={(e) => handleBuyingPriceChange(params.row.id, parseFloat(e.target.value))}
          style={{ width: '80px' }}
        />
      )
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      flex: 1,
      renderCell: (params) => (
        <input
          type="number"
          min="1"
          value={params.row.quantity}
          onChange={(e) => handleQuantityChange(params.row.id, parseInt(e.target.value))}
          style={{ width: '60px' }}
        />
      )
    },
    {
      field: "supplier_id",
      headerName: "Supplier",
      flex: 1,
      renderCell: (params) => (
        <select
          value={params.row.supplier_id || ""}
          onChange={(e) =>
            handleSupplierChange(params.row.id, e.target.value)
          }
          style={{ width: "120px" }}
        >
          <option value="">Select Supplier</option>
          {suppliers.map((sup) => (
            <option key={sup.id} value={sup.id}>
              {sup.name}
            </option>
          ))}
        </select>
      )
    },
    { field: 'total', headerName: 'Total', flex: 1 },
    {
      field: 'purchase_date',          // ✅ match backend
      headerName: 'Purchase Date',
      flex: 1,
      renderCell: (params) => (
        <input
          type="date"
          value={params.row.purchase_date || new Date().toISOString().split("T")[0]}
          onChange={(e) => handleDateChange(params.row.id, e.target.value)}
          style={{ width: '130px' }}
        />
      )
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: (params) => (
        <IconButton
          onClick={() => handleRemove(params.row.id)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px"
          }}
        >
          <DeleteOutlinedIcon style={{ color: "red" }} />
        </IconButton>
      )
    }
  ];
  
  
  
  return (
    <>
    <Box m="20px" mt="80px">
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Header title="Add a Purchase" subtitle="Search for the products" />
        {/*<IconButton
          onClick={() => setIsImportModalOpen(true)}
          sx={{
            fontSize: "13px",
            backgroundColor: tokens.redAccent[300],
            color: tokens.grey[100],
            padding: "14px",
            borderRadius: "15px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            marginTop: "-13px",
            "&:hover": {
              outline: `2px solid ${tokens.redAccent[400]}`,
              backgroundColor: tokens.redAccent[200],
            },
          }}
        >
          Import File <AddOutlinedIcon fontSize="15px" />
        </IconButton>
        */}
      </Box>
  
    {/* Autocomplete + Add Button */}
    <Box display="flex" alignItems="center" width="500px" gap={2} mt="20px">
      <Autocomplete
        style={{flex: 1}}
        options={products}
        getOptionLabel={(option) => option.name}
        value={selectedProduct}
        onChange={(event, newValue) => setSelectedProduct(newValue || null)}
        popupIcon={null}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Product"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <SearchOutlinedIcon style={{ color: tokens.blueAccent[300], marginRight: '8px' }} />
                  {params.InputProps.startAdornment}
                </>
              ),
              disableUnderline: false,
              style: {
                borderBottom: '1px solid #004F92', 
                paddingLeft: "10px", display: 'flex', 
                alignItems: 'center', 
                '&:hover': { borderColor: tokens.blueAccent[300], // or whatever hover color you want 
                }
              },
            }}
          />
        )}
      />

      <IconButton
        onClick={handleAddToTable}
        sx={{
          fontSize: "13px",
          backgroundColor: tokens.redAccent[400],
          border: "none",
          color: tokens.grey[100],
          padding: "14px",
          borderRadius: "15px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
          marginTop: "-13px",
          transition: "all 0.3s ease",
          "&:hover": {
            outline: `2px solid ${tokens.redAccent[400]}`,
            outlineOffset: "1px",
            backgroundColor: tokens.redAccent[200],
          },
          "&:active": {
            outline: `2px solid ${tokens.redAccent[500]}`,
            transform: "scale(0.97)",
          },
        }}
      >
        Add to Table <AddOutlinedIcon fontSize="15px" />
      </IconButton>
    </Box>
  
      {/* Wrapper for the whole section */}
      <Box>
      
        {/* Submit Button aligned to the left */}
        <Box mb={2} display="flex" justifyContent="flex-end">
          <IconButton
            onClick={() => setIsPaymentModalOpen(true)}
            disabled={purchaseItem.length === 0}
            style={{
               fontSize: "13px",
                backgroundColor: tokens.redAccent[400],
                border: "none",
                color: tokens.grey[100],
                padding: "12px 18px",
                borderRadius: "15px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              cursor: purchaseItem.length === 0 ? "not-allowed" : "pointer",
              opacity: purchaseItem.length === 0 ? 0.6 : 1
            }}
          >
            Submit All purchases <AddOutlinedIcon fontSize="small" />
          </IconButton>
        </Box>
      
        {/* Product Table */}
        <Box 
            height="400px"       
        sx={{
           "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: tokens.grey[800],
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: tokens.grey[100],
          },
          "& .MuiCheckbox-root": {
                      border: "none",
                      color: `${tokens.redAccent[400]} !important`,
          },
          "& .MuiDataGrid-columnHeader.action-column--header": {
            background: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: `${tokens.grey[900]} !important`,
            fontSize: "12px",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            color: `${tokens.blueAccent[100]} !important`,
          }
        }}
        >
          <DataGrid
            checkboxSelection rows={purchaseItem}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
          />
        </Box>
      
      </Box>

  </Box>
  <Dialog
    sx={{
      "& .MuiDialog-paper": {
        width: "500px",
        position: "absolute",
        top: "0",
        left: "60%",
        transform: "translateX(-50%)",
      },
    }}
    open={isImportModalOpen}
    onClose={() => setIsImportModalOpen(false)}
  >
    <DialogTitle
      style={{
        background: tokens.redAccent[100],
        color: tokens.blueAccent[300],
        fontSize: "17px",
      }}
    >
      Import File
    </DialogTitle>
  
    <DialogContent style={{ background: tokens.grey[100], padding: "20px 30px" }}>
      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={(e) => setFile(e.target.files[0])}
        style={{ marginTop: "10px" }}
      />
    </DialogContent>
  
    <DialogActions style={{ background: tokens.redAccent[100] }}>
      <Button
        style={{ color: tokens.blueAccent[300] }}
        onClick={() => setIsImportModalOpen(false)}
      >
        Cancel
      </Button>
  
      <Button
        style={{ color: tokens.blueAccent[300] }}
        onClick={uploadExcel}
      >
        Upload
      </Button>
    </DialogActions>
  </Dialog>
  {/* Payment Modal */}
  <Dialog open={isPaymentModalOpen} onClose={() => setIsPaymentModalOpen(false)}>
    <DialogTitle fontSize="20px" backgroundColor={tokens.redAccent[200]} color={tokens.blueAccent[400]}>
      Purchase Payment
    </DialogTitle>
  
    <DialogContent>
  
      <Box mt="20px" mb={2}>
        <strong>Total Amount: {totalPurchaseAmount.toFixed(2)}</strong>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap="10px">
        <TextField
          label="Amount Paid"
          type="number"
          fullWidth
          value={paidAmount}
          onChange={(e) => setPaidAmount(Number(e.target.value))}
          sx={{ mb: 2 }}
        />
    
        <TextField
          label="Balance"
          fullWidth
          value={balance.toFixed(2)}
          disabled
          sx={{ mb: 2 }}
        />
      </Box>
      {balance > 0 && (
        <TextField
          label="Due Date"
          type="date"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={dueDate}
          onChange={(e) => setDueDate(e.target.value)}
        />
      )}
  
    </DialogContent>
  
    <DialogActions style={{ background: tokens.redAccent[200] }} >
      <Button onClick={() => setIsPaymentModalOpen(false)} style={{ color: tokens.blueAccent[400] }}>
        Cancel
      </Button>
  
      <Button onClick={handleSubmitAll} style={{ color: tokens.blueAccent[400] }}>
        Confirm Purchase
      </Button>
    </DialogActions>
  </Dialog>

  </>
    
  );
}

export default AddPurchase;
